/**
 * Tudugu Shopify Customer Account Theme Asset Script
 * Handles native Liquid customer session sync, theme email session sync,
 * and UI binding for profile, orders, and addresses.
 */

(function () {
  /**
   * Trigger Shopify Default Native Customer Account Login
   */
  window.tdgTriggerShopifyEmailLogin = function (email) {
    if (email) {
      window.location.href = `/account/login?email=${encodeURIComponent(email)}&return_to=/`;
    } else {
      window.location.href = '/account/login?return_to=/';
    }
  };

  /**
   * Render Customer Profile Details
   */
  function renderProfile(customer) {
    if (!customer) return;

    const nameEl = document.querySelector('.tdg-profile-name');
    const emailEl = document.getElementById('tdg-profile-email');
    const mobileEl = document.getElementById('tdg-profile-mobile');
    const emailBadge = document.getElementById('tdg-profile-email-badge');

    if (nameEl) {
      nameEl.textContent = customer.displayName || `${customer.firstName || ''} ${customer.lastName || ''}`.trim() || 'Valued Customer';
    }

    if (emailEl && (customer.emailAddress?.emailAddress || customer.email)) {
      const emailVal = customer.emailAddress?.emailAddress || customer.email;
      emailEl.textContent = emailVal;
      if (emailBadge && emailVal) emailBadge.style.display = 'inline-block';
    }

    if (mobileEl && (customer.phoneNumber?.phoneNumber || customer.phone)) {
      mobileEl.textContent = customer.phoneNumber?.phoneNumber || customer.phone;
    }
  }

  /**
   * Render Saved Addresses Grid
   */
  function renderAddresses(addresses) {
    if (!addresses || !addresses.length) return;

    const gridContainer = document.querySelector('.tdg-addresses-grid');
    if (!gridContainer) return;

    let html = '';
    addresses.forEach((item, index) => {
      const addr = item.node || item;
      const cityTag = (addr.city || `ADDRESS ${index + 1}`).toUpperCase();

      html += `
        <div class="tdg-address-card-item">
          <div class="tdg-address-tag">${cityTag}</div>
          <h3 class="tdg-address-name">${addr.firstName || ''} ${addr.lastName || ''}</h3>
          <p class="tdg-address-lines">
            ${addr.address1 || ''}${addr.address2 ? ', ' + addr.address2 : ''}<br>
            ${addr.city || ''}${addr.zip ? ' - ' + addr.zip : ''}${addr.province ? ', ' + addr.province : ''}
            ${addr.country ? ', ' + addr.country : ''}
          </p>
          ${addr.phoneNumber || addr.phone ? `<p class="tdg-address-phone"><strong>+91- ${addr.phoneNumber || addr.phone}</strong></p>` : ''}
          <div class="tdg-address-actions">
            <button type="button" class="tdg-action-link tdg-edit-addr-btn" data-id="${addr.id || index}">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              Edit
            </button>
          </div>
        </div>
      `;
    });

    gridContainer.innerHTML = html;
  }

  /**
   * Render Customer Orders Card List
   */
  function renderOrders(orders) {
    if (!orders || !orders.length) return;

    const ordersListContainer = document.getElementById('tdg-real-orders-list') || document.getElementById('tdg-otp-dynamic-orders-container');
    if (!ordersListContainer) return;

    ordersListContainer.style.display = 'flex';

    let html = '';
    orders.forEach((item) => {
      const order = item.node || item;
      const primaryItem = order.lineItems?.edges?.[0]?.node || order.line_items?.[0] || {};
      const imgUrl = primaryItem.image?.url || primaryItem.image || '';

      const rawStatus = String(order.fulfillmentStatus || order.fulfillment_status || order.fulfillment_status_label || 'CONFIRMED').toUpperCase();
      const tagsStr = (Array.isArray(order.tags) ? order.tags.join(',') : (order.tags || '')).toLowerCase();
      const stLower = rawStatus.toLowerCase();

      const isCancelled = Boolean(order.cancelled) || stLower === 'cancelled' || tagsStr.includes('cancelled');
      const isReturn = !isCancelled && (Boolean(order.return_requested) || tagsStr.includes('return initiated') || tagsStr.includes('return_requested') || stLower.includes('return') || tagsStr.includes('exchange initiated') || stLower.includes('exchange'));
      const isExchange = isReturn && (order.return_type === 'Exchange' || tagsStr.includes('exchange') || stLower.includes('exchange'));
      const isModified = !isCancelled && !isReturn && (Boolean(order.modified) || tagsStr.includes('modified') || stLower === 'modified');
      const isDelivered = !isCancelled && !isReturn && !isModified && (stLower === 'fulfilled' || stLower === 'delivered' || tagsStr.includes('delivered'));
      const isInTransit = !isCancelled && !isReturn && !isModified && !isDelivered && (stLower === 'shipped' || stLower === 'in_transit' || stLower === 'in transit' || stLower === 'out_for_delivery' || tagsStr.includes('in transit') || tagsStr.includes('shipped'));
      const isProcessing = !isCancelled && !isReturn && !isModified && !isDelivered && !isInTransit && (stLower === 'processing' || stLower === 'partial' || stLower === 'partially_fulfilled' || tagsStr.includes('processing'));

      const createdAt = order.processedAt || order.created_at ? new Date(order.processedAt || order.created_at) : null;
      const ageDays = createdAt ? ((new Date() - createdAt) / (1000 * 60 * 60 * 24)) : 0;

      let badgeLabel = 'CONFIRMED';
      let badgeClass = 'tdg-badge-confirmed';
      let badgeStyle = 'background:#E0EDC6; color:#385E28;';

      if (isCancelled) {
        badgeLabel = 'CANCELLED';
        badgeClass = 'tdg-badge-cancelled';
        badgeStyle = 'background:#8D4A32; color:#ffffff;';
      } else if (isExchange) {
        badgeLabel = 'EXCHANGE INITIATED';
        badgeClass = 'tdg-badge-returned';
        badgeStyle = 'background:#D9E9F7; color:#1C4E80;';
      } else if (isReturn) {
        badgeLabel = 'RETURN INITIATED';
        badgeClass = 'tdg-badge-returned';
        badgeStyle = 'background:#D9E9F7; color:#1C4E80;';
      } else if (isModified) {
        badgeLabel = 'MODIFIED';
        badgeClass = 'tdg-badge-modified';
        badgeStyle = 'background:#FFF3D6; color:#8A6200;';
      } else if (isDelivered) {
        badgeLabel = 'DELIVERED';
        badgeClass = 'tdg-badge-delivered';
        badgeStyle = 'background:#E0EDC6; color:#385E28;';
      } else if (isInTransit) {
        badgeLabel = 'IN TRANSIT';
        badgeClass = 'tdg-badge-intransit';
        badgeStyle = 'background:#E0EDC6; color:#385E28;';
      } else if (isProcessing) {
        badgeLabel = 'PROCESSING';
        badgeClass = 'tdg-badge-modified';
        badgeStyle = 'background:#FFF3D6; color:#8A6200;';
      }

      const totalAmount = order.totalPrice ? `${order.totalPrice.currencyCode || '₹'} ${order.totalPrice.amount}` : order.total_price || '';
      const orderDate = order.processedAt || order.created_at ? new Date(order.processedAt || order.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).toUpperCase() : '';
      const detailUrl = `/pages/order-details?id=${encodeURIComponent(order.id || '')}&name=${encodeURIComponent(order.name || order.orderNumber || '')}`;
      const buyUrl = primaryItem.url || '/collections/all';

      let actionsHtml = '';
      if (isCancelled) {
        actionsHtml = `
          <a href="${buyUrl}" class="tdg-od-btn-primary-green">Re Order</a>
          <a href="${detailUrl}" class="tdg-od-btn-brown-action">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:16px; height:16px; min-width:16px; min-height:16px; display:inline-block;"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            <span>VIEW DETAILS</span>
          </a>
        `;
      } else if (isDelivered) {
        let returnBtn = '';
        if (ageDays <= 14 || !createdAt) {
          returnBtn = `
            <a href="${detailUrl}#return" class="tdg-od-btn-brown-action">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:16px; height:16px; min-width:16px; min-height:16px; display:inline-block;"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/></svg>
              <span>RETURN ITEM</span>
            </a>
          `;
        }
        actionsHtml = `
          <a href="${buyUrl}" class="tdg-od-btn-primary-green">Buy Again</a>
          <a href="${detailUrl}#review" class="tdg-od-btn-brown-action">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:16px; height:16px; min-width:16px; min-height:16px; display:inline-block;"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            <span>WRITE REVIEW</span>
          </a>
          ${returnBtn}
        `;
      } else if (isInTransit) {
        // IN TRANSIT: Only Track Order button!
        actionsHtml = `
          <a href="${detailUrl}" class="tdg-od-btn-primary-green">Track Order</a>
        `;
      } else {
        // CONFIRMED / PROCESSING: Track Order + (Cancel & Modify if age <= 3 days)
        let cancelModifyBtns = '';
        if (ageDays <= 3 || !createdAt) {
          cancelModifyBtns = `
            <a href="/pages/cancel-order?id=${encodeURIComponent(order.id || '')}&name=${encodeURIComponent(order.name || order.orderNumber || '')}" class="tdg-od-btn-brown-action">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:16px; height:16px; min-width:16px; min-height:16px; display:inline-block;"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
              <span>CANCEL ITEM</span>
            </a>
            <a href="/pages/modify-order?id=${encodeURIComponent(order.id || '')}&name=${encodeURIComponent(order.name || order.orderNumber || '')}" class="tdg-od-btn-brown-action">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:16px; height:16px; min-width:16px; min-height:16px; display:inline-block;"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>
              <span>MODIFY ITEM</span>
            </a>
          `;
        }
        actionsHtml = `
          <a href="${detailUrl}" class="tdg-od-btn-primary-green">Track Order</a>
          ${cancelModifyBtns}
        `;
      }

      let mobileStTitle = 'Order Confirmed';
      if (isCancelled) mobileStTitle = 'Order Cancelled';
      else if (isExchange) mobileStTitle = 'Exchange Initiated';
      else if (isReturn) mobileStTitle = 'Return Initiated';
      else if (isModified) mobileStTitle = 'Order Modified';
      else if (isDelivered) mobileStTitle = 'Delivered';
      else if (isInTransit) mobileStTitle = 'In Transit';
      else if (isProcessing) mobileStTitle = 'Processing';

      const mobileStClass = isCancelled ? 'tdg-mobile-st-cancelled' : (isDelivered ? 'tdg-mobile-st-delivered' : 'tdg-mobile-st-placed');
      const mobileSubText = isCancelled ? 'As per your request' : (isDelivered ? 'Delivered' : (isInTransit ? 'In Transit' : (isProcessing ? 'Processing' : 'Order Confirmed')));
      const variantTitle = primaryItem.variant?.title || primaryItem.variant_title || 'XL';
      const mobileSizeText = variantTitle.includes('Size:') ? variantTitle : `Size: ${variantTitle.replace('Default Title', 'XL')}`;

      html += `
        <div class="tdg-order-card" data-order-date="${order.processedAt || order.created_at || ''}" data-status="${badgeLabel}" onclick="if(window.innerWidth <= 767) window.location.href='${detailUrl}';">
          <div class="tdg-order-card-media">
            <span class="tdg-order-status-badge ${badgeClass}" style="${badgeStyle}">${badgeLabel}</span>
            ${imgUrl ? `<img src="${imgUrl}" alt="${primaryItem.title || ''}" loading="lazy" class="tdg-order-card-img">` : `
              <div class="tdg-order-card-img-placeholder">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/></svg>
              </div>
            `}
          </div>
          <div class="tdg-mobile-order-card-info">
            <div class="tdg-mobile-card-top-row">
              <span class="tdg-mobile-status-title ${mobileStClass}">${mobileStTitle}</span>
              <svg class="tdg-mobile-card-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
            <div class="tdg-mobile-card-subtitle">${mobileSubText}</div>
            <div class="tdg-mobile-card-details">${mobileSizeText} &nbsp;&bull;&nbsp; Qty: ${primaryItem.quantity || 1}</div>
          </div>
          <div class="tdg-order-card-content">
            <div class="tdg-order-card-meta-row">
              <span class="tdg-order-number-date">ORDER ${order.name || order.orderNumber || order.order_number || ''} &nbsp;&bull;&nbsp; ${orderDate}</span>
              <div class="tdg-order-total-block">
                <span class="tdg-order-total-label">TOTAL</span>
                <span class="tdg-order-total-amount">${totalAmount}</span>
              </div>
            </div>
            <div class="tdg-order-card-info">
              <h3 class="tdg-order-product-title">
                <a href="${detailUrl}">${primaryItem.title || 'Artisanal Collection Item'}</a>
              </h3>
              <p class="tdg-order-product-desc">
                Qty: ${primaryItem.quantity || 1} &bull; Status: ${order.financialStatus || order.financial_status || 'PAID'}
              </p>
            </div>
            <div class="tdg-order-card-actions" style="border-top: 1px solid #E8E3DA; padding-top: 14px; margin-top: 14px; gap: 20px; display: flex; align-items: center; flex-wrap: wrap;">
              ${actionsHtml}
            </div>
          </div>
        </div>
      `;
    });

    ordersListContainer.innerHTML = html;
  }

  /**
   * Update Storewide UI Components
   */
  function updateStorewideUI(customer) {
    if (!customer) return;

    window.TuduguCustomer = customer;
    window.dispatchEvent(new CustomEvent('tdg:customer:loaded', { detail: customer }));

    const displayName = customer.firstName || customer.displayName || 'ACCOUNT';
    const accountButtons = document.querySelectorAll('[data-open-signin-modal], .tds-ecom-signin, .header__icon--account');

    accountButtons.forEach(btn => {
      const textSpan = btn.querySelector('span:not(.svg-wrapper)');
      if (textSpan) {
        textSpan.textContent = `MY ACCOUNT (${displayName.toUpperCase()})`;
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/pages/profile';
      }, true);
    });

    renderProfile(customer);
    if (customer.addresses?.edges || customer.addresses) renderAddresses(customer.addresses.edges || customer.addresses);
    if (customer.orders?.edges || customer.orders) renderOrders(customer.orders.edges || customer.orders);

    const guestView = document.getElementById('tdg-guest-orders-view');
    const loggedInView = document.getElementById('tdg-logged-in-orders-view');
    if (guestView) guestView.style.display = 'none';
    if (loggedInView) loggedInView.style.display = 'block';
  }

  /**
   * Initialize Customer Dashboard
   */
  function initCustomerDashboard() {
    let customer = null;

    if (window.ShopifyCustomer && window.ShopifyCustomer.isLoggedIn) {
      customer = {
        id: window.ShopifyCustomer.id,
        firstName: window.ShopifyCustomer.firstName,
        lastName: window.ShopifyCustomer.lastName,
        displayName: window.ShopifyCustomer.name || `${window.ShopifyCustomer.firstName || ''} ${window.ShopifyCustomer.lastName || ''}`.trim() || 'Valued Member',
        emailAddress: { emailAddress: window.ShopifyCustomer.email },
        phoneNumber: { phoneNumber: window.ShopifyCustomer.phone }
      };
    }

    const storedEmail = localStorage.getItem('tdg_customer_email') || 
                        sessionStorage.getItem('tds_customer_email') || 
                        localStorage.getItem('tdg_pending_email');

    if (!customer && storedEmail) {
      const namePart = storedEmail.split('@')[0];
      customer = {
        id: 'email_session_' + Date.now(),
        firstName: namePart,
        displayName: namePart.charAt(0).toUpperCase() + namePart.slice(1),
        emailAddress: { emailAddress: storedEmail }
      };
    }

    if (customer) {
      updateStorewideUI(customer);
    }
  }

  // Listen for real-time Email OTP authentication events
  window.addEventListener('tdg:customer:authenticated', function(e) {
    if (e.detail && e.detail.email) {
      const namePart = e.detail.email.split('@')[0];
      const customer = {
        id: 'email_session_' + Date.now(),
        firstName: namePart,
        displayName: namePart.charAt(0).toUpperCase() + namePart.slice(1),
        emailAddress: { emailAddress: e.detail.email }
      };
      updateStorewideUI(customer);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomerDashboard);
  } else {
    initCustomerDashboard();
  }
})();
